import React from 'react'
import ResetPasswordForm from '@/components/auth/ResetPasswordForm'
import '@/styles/pages/login.css'

/**
 * Reset-password page reuses the login shell so the customer's
 * journey from "Forgot your password?" link → email → reset form →
 * sign in stays inside the same two-column popup look. The right-
 * hand step area swaps in ResetPasswordForm in place of the login
 * flow's step components.
 */
function ResetPasswordPage(): React.JSX.Element {
  return (
    <div className="login-page-wrap">
      <div className="login-page-content">
        <div className="login-page">
          <aside className="login-page-panel">
            <div className="login-page-panel-inner">
              <img
                src="/mcqueens-logo.png"
                alt="McQueens Dairies"
                className="login-page-logo"
              />
              <h2 className="login-page-tagline">Your milk delivery, online.</h2>
              <ul className="login-page-bullets">
                <li>Pause and resume deliveries any time.</li>
                <li>Change your weekly order in seconds.</li>
                <li>Update your address, payment details, and contact info.</li>
                <li>See what's coming and when.</li>
              </ul>
            </div>
          </aside>

          <main className="login-page-main">
            <div className="login-page-step-container">
              <ResetPasswordForm />
            </div>
          </main>
        </div>
      </div>

      <footer className="login-page-footer">
        <p>&copy; {new Date().getFullYear()} McQueens Dairies</p>
        <nav>
          <a
            href="https://www.mcqueensdairies.co.uk/privacy-and-cookies-policy/"
            target="_blank"
            rel="noreferrer"
          >
            Privacy Policy
          </a>
          <a
            href="https://www.mcqueensdairies.co.uk/terms-and-conditions/"
            target="_blank"
            rel="noreferrer"
          >
            Terms and Conditions
          </a>
          <a
            href="https://www.mcqueensdairies.co.uk/help/"
            target="_blank"
            rel="noreferrer"
          >
            Contact Us
          </a>
        </nav>
      </footer>
    </div>
  )
}

export default ResetPasswordPage
